export function getFileExtension(filename) {
    if (typeof filename !== 'string') return '';
    const lastDot = filename.lastIndexOf('.');
    if (lastDot === -1 || lastDot === filename.length - 1) return '';
    let ext = filename.substring(lastDot + 1).toLowerCase();
    if(ext.includes('?')) ext = ext.substring(0, ext.indexOf('?'));
    return ext;
}

export function hiddenLink(url){
    if(!url || typeof url !== 'string') return;

    let filename = url.substring(url.lastIndexOf('/') + 1);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;

    document.body.appendChild(link); // Needed for Firefox
    link.click();
    document.body.removeChild(link);
}

export function deepMerge(target, ...sources) {
    if (!sources.length) return target;

    for (const source of sources) {
        if (source && isObject(source)) {
            for (const key in source) {
                const sourceVal = source[key];
                const targetVal = target[key];

                if (Array.isArray(sourceVal)) {
                    target[key] = Array.isArray(targetVal) ? deepMerge([], targetVal, sourceVal) : [...sourceVal];
                } else if (isObject(sourceVal)) {
                    target[key] = deepMerge(isObject(targetVal) ? targetVal : {}, sourceVal);
                } else if(typeof sourceVal !== 'undefined') {
                    target[key] = sourceVal;
                }
            }
        }
    }

    return target;
}

export function continueOnDocVisible(){
    return new Promise(resolve => {
        if (document.visibilityState === 'visible') {
            resolve();
            return;
        } 
    
        const onVisible = () => {
            document.removeEventListener('visibilitychange', onVisible);
            resolve();
        };
        document.addEventListener('visibilitychange', onVisible);
    });
}

export async function inputToSHA256(input){
    const utf8 = new TextEncoder().encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

export function minsToMills(mins){
    return mins * 1000 * 60;
}

export function removeDotFromUrl(url){
    if(url[0] == '.') return url.substring(1);
    return url;
}

export function gatherPathsFromString(str){
    let res = [];

    const EXTENSION_LIST = ['.jpg', '.png', '.svg', '.css', '.html'];
    for(let i = 0, len = EXTENSION_LIST.length; i < len; i++){
        let ext = EXTENSION_LIST[i];
        let searchStartInd = 0;
    
        let extInd = null;
        while((extInd = str.indexOf(ext, searchStartInd)) != -1){
            let targetStart = null;
    
            for(let i = extInd; i >= 0; i--){
                let char = str[i];
                if(!char || char == '\'' || char == '"' || char == '`' || char == '(') {
                    let charPrev = str[i + 1];
                    if(charPrev == '/' || charPrev == '.') targetStart = i + 1;
                    break;
                }
            }
    
            if(!targetStart) {
                searchStartInd = extInd + 1;
                continue;
            }
    
            let targetEnd = null;
    
            for(let i = extInd, len = str.length; i < len; i++){
                let char = str[i];
                if(!char || char == '\'' || char == '"' || char == '`' || char == ')'){
                    targetEnd = i;
                    break;
                }
            }
    
            if(!targetEnd) targetEnd = str.length - 1;
    
            res.push(str.substring(targetStart, targetEnd));
    
            searchStartInd = targetEnd;
        }
    }

    return res;
}

export function createCORSSafeWorker(workerUrl){
    const js = `import ${JSON.stringify(new URL(workerUrl, import.meta.url))}`
    const blob = new Blob([js], { type: "application/javascript" })
    const objURL = URL.createObjectURL(blob)
    const worker = new Worker(objURL, { type: "module" })
    worker.addEventListener("error", (e) => {
        URL.revokeObjectURL(objURL);
    })
    return worker;
}

export function removeItemFromArray(arr, item){
    if(!Array.isArray(arr)) return;
    if(arr.includes(item)) arr.splice(arr.indexOf(item), 1);
}

export function getKey(value, obj){
    return Object.keys(obj).find(key => obj[key] == value);
}

export function addDirPath(){
    var args = Array.prototype.slice.call(arguments);
    if(args.length < 2)
        throw "At least two params required. ";

    var path = args[0];
    while(path.charAt(path.length - 1) === '/')
        path = path.substring(0, path.length - 1);

    for(var i = 1, j = args.length; i < j; i++){
        var arg = args[i];
        path += !arg ? '' : ((arg + '').charAt(0) === '/' ? arg : `/${arg}`);
    }

    return path;
}
export function addQueryStringValues(url, params){
    if(!isObject(params)) return url;

    var searchStartIndex = url.indexOf('?');
    if(searchStartIndex !== -1){
        var searchStr = url.substr(searchStartIndex);
        url = url.replace(searchStr, '');
        var search = getLocationSearch(searchStr);
        params = Object.assign({}, search, params);
    }

    for(var key in params){
        var val = params[key];
        url += (url.indexOf('?') == -1 ? '?' : '&') + key + '=' + val;
    }

    return url;
}
export function getParameterByName(nameOrFunct) {
    if(typeof nameOrFunct === 'function'){
        let res = {};
        let params = getLocationSearch();
        Object.keys(params).forEach(key => {
            if(nameOrFunct(key.toLowerCase())) res[key] = params[key];
        });
        return res;
    }

    return getPropIgnoreCase(getLocationSearch(), nameOrFunct);
}
export function clearLocationSearch(){
    if(!window.history || !window.history.replaceState) return;

    var args = Array.prototype.slice.call(arguments);
    var searchArgs = getLocationSearch();

    let firstArg = args[0];
    if(typeof firstArg === 'function'){
        Object.keys(searchArgs).forEach(key => {
            if(firstArg(key.toLowerCase())) delete searchArgs[key];
        });
    }
    else{
        for(var i = 0, j = args.length; i < j; i++){
            var key = getPropIgnoreCase(searchArgs, args[i], true);
            delete searchArgs[key];
        }
    }

    setLocationSearch(null, addQueryStringValues(window.location.pathname, searchArgs));
}
export function setLocationSearch(params, locSearchPathname, shouldSetDefaultPath){
    typeof shouldSetDefaultPath !== 'boolean' && (shouldSetDefaultPath = true);
    locSearchPathname = (shouldSetDefaultPath && !locSearchPathname) ? (window.location.pathname + window.location.search) : locSearchPathname;
    if(locSearchPathname.charAt(0) !== '/') locSearchPathname = '/' + locSearchPathname;
    window.history.replaceState(window.currentState, document.title, addQueryStringValues(locSearchPathname, params));
}
export function getLocationSearch(strSearch){
    var search = typeof strSearch === 'string' ? strSearch : window.location.search;
    var searchArgs = {};
    if(search){
        search = search.replace('?', '').split('&');
        for(var i = 0, j = search.length; i < j; i++){
            var arg = search[i];
            var equalsInd = arg.indexOf('=');
            if(equalsInd === -1)
                continue;

            var key = arg.substring(0, equalsInd);
            var val = arg.substring(equalsInd + 1);
            searchArgs[key] = val;
        }
    }
    return searchArgs;
}
export function getDateUTCParams(strDate){
    var params = strDate.split(/\D/);

    for(var i = 0, j = params.length; i < j; i++){
        params[i] = Number(params[i]);
    }

    if(params.length > 1)
        params[1]--;

    return params;
}
export function firstIfUndefined(object){
    if(Array.isArray(object) || !isObject(object)) return object;

    let args = Array.prototype.slice.call(arguments);
    let len = args.length;

    let returnValAndKey = args[len - 1];
    if(typeof returnValAndKey === 'boolean' && returnValAndKey) len--;
    else returnValAndKey = false;

    for(let i = 1; i < len; i++){
        let key = args[i];
        let val = typeof key === 'undefined' ? key : object[key];

        let keyToReturn = key;
        
        if(((typeof val === 'number' && !isNaN(val)) || (typeof val === 'boolean' && !val) || val === null) ? false : !val){
            if(i !== len - 1) continue;

            keyToReturn = Object.keys(object)[0];
            val = object[keyToReturn];
        }
        
        if(returnValAndKey) return {val, key: keyToReturn};
        return val;
    }
}
export function toArray(arr, nullifyIfFalsy){
    if(typeof nullifyIfFalsy === 'boolean' && nullifyIfFalsy && !Boolean(arr) && typeof arr !== 'number') return null;
    if(!Array.isArray(arr)){
        if(typeof arr === 'undefined') return [];
        return [arr];
    }
    return arr;
}

function unwrap(value){
    if(typeof value === 'object' && value !== null)
        return JSON.stringify(value);
    return value;
}

function removeStringQuotes(value, paramsStr){
    if(typeof value === 'object' && value !== null){
        var val = unwrap(value);
        var valQuotes = '"' + val + '"';
        while(paramsStr.includes(valQuotes))
            paramsStr = paramsStr.replace(valQuotes, val);
        return paramsStr;
    }
    return paramsStr;
}

export function appendParamsToJson(target, params){
    if(typeof target !== 'object' || target === null || typeof params !== 'object' || params === null)
        return target;

    var paramsStr = JSON.stringify(params);
    for(var key in params){
        var val = params[key];
        paramsStr = paramsStr.replace(new RegExp('\\{' + key + '\\}', 'gi'), unwrap(val));
        paramsStr = removeStringQuotes(val, paramsStr);
    }
    params = JSON.parse(paramsStr);

    var targetStr = JSON.stringify(target);
    for(var key in params){
        var val = params[key];
        targetStr = targetStr.replace(new RegExp('\\{' + key + '\\}', 'gi'), unwrap(val));
        targetStr = removeStringQuotes(val, targetStr);
    }
    return JSON.parse(targetStr);
}
export function isObject(obj){
    return typeof obj === 'object' && obj !== null;
}
export function escape(str){
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");      
}
export function setDateTwoDigits(num){
    if(Number(num) < 10) return '0' + num;
    return num;
}
export function toggleFullscreen(element){
    if (inFS()) {
        if(document.exitFullscreen) document.exitFullscreen();
        else if(document.mozCancelFullScreen) document.mozCancelFullScreen();
        else if(document.webkitExitFullscreen) document.webkitExitFullscreen();
        else if(document.msExitFullscreen) document.msExitFullscreen();
    } else {
        if(element.requestFullscreen) element.requestFullscreen();
        else if(element.mozRequestFullScreen) element.mozRequestFullScreen();
        else if(element.webkitRequestFullscreen) element.webkitRequestFullscreen();
        else if(element.msRequestFullscreen) element.msRequestFullscreen();
    }
    return inFS();
}
export function supportsFullscreen(){
    return Boolean(document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen);
}
export function addFullscreenExitCallback(callback){
    document.addEventListener('webkitfullscreenchange', exitHandler, false);
    document.addEventListener('mozfullscreenchange', exitHandler, false);
    document.addEventListener('fullscreenchange', exitHandler, false);
    document.addEventListener('MSFullscreenChange', exitHandler, false);

    function exitHandler(){
        typeof callback === 'function' && callback(inFS());
    }
}
export function validateCC(value) {
    return /^[+0-9]{2,}$/.test(value) && value.charAt(0) == '+';
}
export function randomizeToken(token){
    var timestamp = Date.now();
    var newToken = timestamp+"/"+token
    var encoded = btoa(newToken)
    var encoded = encoded.split('').map(function(c){
    return c === c.toUpperCase()
    ? c.toLowerCase()
    : c.toUpperCase()
    }).join('')
    return encoded.replace(/=/gi, '');
}
export function addToArrayIfExists(object, propName, arr, addItemsLast){
    if(typeof addItemsLast !== 'boolean') addItemsLast = true;

    Array.isArray(object[propName]) ? (object[propName] = (addItemsLast ? object[propName].concat(arr) : arr.concat(object[propName]))) : (object[propName] = arr);
}
export function toLocaleDate(dateStr, language, options){
    var date = new Date(dateStr);
    options = options || {};
    return date.toLocaleDateString(language, Object.assign({
        year: 'numeric', 
        month: 'long', 
        day: 'numeric',
    }, options)) + ' ' + date.toLocaleTimeString(language);
}
export function getPaths(strPaths){
    var paths = (strPaths || window.location.pathname).split('/');
    
    for(var i = 0, j = paths.length; i < j; i++){
        if(!paths[i]){
            paths.splice(i, 1);
            i--;
            j--;
        }
    }

    paths.forEach((path, index) => paths[index] = path ? decodeURI(path) : path);

    return paths;
}
export function arrayMax(arr, callback){
    arr = toArray(arr);
    var maxItem = null;
    var maxVal = 0;
    for(var i = 0, j = arr.length; i < j; i++){
        var item = arr[i];
        var val = callback(item);
        if(!maxItem){
            maxItem = item;
            maxVal = val;
        }
        else
        {
            if(val > maxVal){
                maxItem = item;
                maxVal = val;
            }
        }
    }
    return maxItem;
}
export function removeEmptyFromArr(arr){
    return (Array.isArray(arr) ? arr : []).filter(item => typeof item !== 'undefined' && item !== null && item !== '');
}
export function toDashCase(str){
    return str.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
}
export function toPascalCase(dasherized) {
    return dasherized.replace(/(^|-)([a-z])/g, function (g, m1, m2) { return m2.toUpperCase(); });
}
export function createObjectUrlFromString(str){
    window.URL = window.URL || window.webkitURL;

    var blob;
    try {
        blob = new Blob([str], {type: 'application/javascript'});
    } catch (e) { // Backwards-compatibility
        window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;
        blob = new BlobBuilder();
        blob.append(str);
        blob = blob.getBlob();
    }

    return URL.createObjectURL(blob);
}
export function lastProp(object){
    var keys = Object.keys(object);
    var len = keys.length;
    return len > 0 ? object[keys[len - 1]] : null;
}
export function getKeyByValue(object, value) {
    return Object.keys(object).find(function(key){
        return object[key] === value;
    });
}
export function appendParamsToString(str, params){
    if(typeof str !== 'string')
        return null;
    for(var key in params)
        str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), params[key]);
    return str;
}
export function checkTimstpBetweenCurrTimstp(dateFrom, dateTo){
    if(isNaN(dateFrom) || isNaN(dateTo)){
        console.warn('Invalid date. ');
        return false;
    }
    else if(dateFrom > dateTo){
        console.warn('\'dateFrom\' should not be greater than \'dateTo\'');
        return false;
    }

    var dateNow = Date.now();
    return dateFrom < dateNow && dateTo > dateNow;
}

export const exec = (function(){
    let cachedList = {};

    return function(strFunctBody, thisVal){
        if(typeof strFunctBody === 'function'){
            strFunctBody.call(thisVal);
            return;
        }
    
        var cachedItem = cachedList[strFunctBody];
        if(typeof cachedItem !== 'undefined'){
            if(typeof cachedItem === 'function') return cachedItem.call(thisVal);
            return cachedItem;
        }
    
        var hasThisVal = typeof thisVal !== 'undefined';
        var callback = (Function(`return ${strFunctBody};`));
        var result = hasThisVal ? callback.call(thisVal) : callback();
        cachedList[strFunctBody] = hasThisVal ? callback : result;
        return result;
    }
}());

export const deaccent = (function(){
    let accents = {
        a: 'àáâãäåæ',
        c: 'çćč',
        d: 'đ',
        e: 'èéêëæ',
        i: 'ìíîï',
        n: 'ñ',
        o: 'òóôõöø',
        s: 'ßš',
        u: 'ùúûü',
        y: 'ÿ',
    };
    
    for(var key in accents) accents[key] = new RegExp('[' + accents[key] + ']', 'gi');
    
    return function(input){
        for(var key in accents)
            input = input.replace(accents[key], key);
        return input;
    };
}());

export function deaccentAndStripWhitespace(input){
    return deaccent(input).toLowerCase().replace(/[\W_]+/g, '');
}

export function compareStrings(str1, str2){
    return deaccentAndStripWhitespace(str1) == deaccentAndStripWhitespace(str2);
}

export function compareStringsIgnoreCase(str1, str2){
    str1 = deaccentAndStripWhitespace(str1);
    str2 = deaccentAndStripWhitespace(str2);
    return str1 == str2 || str1.includes(str2) || str2.includes(str1);
}

/**
 * Forcing lowercasing the first character of a potential property name, since javascript 
 * variable / property names should ideally not be capitalized, in most cases.
 * @param  {String} str String to input. 
 * @return {String}     Outputs the string with the first character lowercased. If the potential property name starts off 
 *                      with an uppercased acronym, then the original string is returned. 
 */
export function propNameLowerCase(str){
	/*
	* Preventing lowercasing the first character in case the property name is an uppercased 
	* acronym (e.g. the property "SWIFT" should not be casted to "sWIFT"). 
	*/
	if(str.length > 1 && str.charAt(1).toUpperCase() == str.charAt(1)) return str;
	return str.charAt(0).toLowerCase() + str.substring(1);
}

export function arrayFirst(arr, callback){
    return toArray(arr).find(callback);
}
export function arrayFilter(arr, callback){
    return toArray(arr).filter(callback);
}

var charsToEncode = {
    '%': '%25',
    ' ': '%20',
    '\r\n': '%0D%0A',
    '=': '%3D',
    '&': '%26',
};

export function toRealText(expectedStrHtml){
    expectedStrHtml = expectedStrHtml || "";
    expectedStrHtml = expectedStrHtml.replace(/\s\s+/g, ' ');
    expectedStrHtml = expectedStrHtml.replace(/<br\s*[\/]?>/gi, '\r\n');
    expectedStrHtml = expectedStrHtml.replace(/<\/li>/gi, '\r\n');
    expectedStrHtml = expectedStrHtml.replace(/<li>/gi, ' - ');
    expectedStrHtml = expectedStrHtml.replace(/\t/gi, '');
    expectedStrHtml = expectedStrHtml.replace(/<ul>|<\/ul>|<b>|<\/b>/gi, '');

    for(var char in charsToEncode){
        var encChar = charsToEncode[char];
        expectedStrHtml = expectedStrHtml.replace(new RegExp(char, 'g'), encChar);
    }

    return expectedStrHtml;
}

export function getBase64(file, onSuccess, onError){
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function(e){
        typeof onSuccess === 'function' && onSuccess(e);
    };
    reader.onerror = function(error){
        typeof onError === 'function' && onError(error);
    };
}
export function toHex(str){
    var dec = str.toString().split(''), sum = [], hex = [], i, s
    while(dec.length){
        s = 1 * dec.shift()
        for(i = 0; s || i < sum.length; i++){
            s += (sum[i] || 0) * 10
            sum[i] = s % 16
            s = (s - sum[i]) / 16
        }
    }
    while(sum.length){
        hex.push(sum.pop().toString(16))
    }
    return hex.join('').toUpperCase();
}
export function setProperty(object, propName, value){
    value = value || {};
    object[propName] = value;
    return value;
}
export function deviceHasTouchPoints(){
    return 'ontouchstart' in window || (navigator.maxTouchPoints > 0);
}
export function checkIfMobileViaRegexp(){
    var check = false;
    (function(a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
export function mobileAndTabletCheck() {
    if(deviceHasTouchPoints() && (window.screen.availWidth || window.innerWidth) < 1300) return true;
    return checkIfMobileViaRegexp();
}
export function convertBoolean(value){
    if(!value)
        return value;

    value = value.toLowerCase();
    return (typeof value === 'string' && (value == 'true' || value == 'false')) ? value == 'true' : value;
}
export function generateUniqueId(){
    return new Date().getTime().toString(36) + Math.round(Math.random()*500)
}
export function generateUToken () {
    var a = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx';
    a = a.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    return a;
}
export const extendFunct = (function(){
    var arr = [];

    /**
     * Extends an already existing function of an object. 
     * @param  {Object}   parent    The parent object of the function. 
     * @param  {String}   functName The name of the function. 
     * @param  {Function} callback  The function to extend the existing function with. 
     * @param  {Boolean}  reverse   If true, the callback is pushed at the beginning of the array, otherwise it'll be pushed at the end. 
     * @param  {Boolean}  remove    If true, the existing extended counterpart will be removed.  
     */
    return function(parent, functName, callback, reverse, remove){
        if(typeof reverse !== 'boolean')
            reverse = false;

        if(typeof remove !== 'boolean')
            remove = false;

        if(typeof callback !== 'function')
            throw 'Callback should be a Function.';

        if(!functName || !parent)
            return;

        /*
            As odd as it sounds, we do have some functions that are 
            represented by an integer. Henceforth why the function name should 
            be parsed to a string. See 'model.domainProps' for more info. 
        */
        functName = functName + '';

        var item = arr.find(item => item.parent === parent && item.functName === functName);
        if(!item){
            item = {
                parent: parent,
                functName: functName,
                callbacks: [],
            };

            /*
                Checking if the parent object already has a function 
                denoted by 'functName'. If it has, that function should should
                be the first callback in the array. 
            */
            if(typeof parent[functName] === 'function')
                item.callbacks.push(parent[functName]);

            arr.push(item);

            parent[functName] = (function(item){
                return function(){
                    for(var i = 0, j = item.callbacks.length; i < j; i++){
                        var cb = item.callbacks[i];
                        typeof cb === 'function' && cb.apply(this, arguments);
                    }
                };
            }(item));
        }
        
        if(remove){
            var ind = item.callbacks.indexOf(callback);
            ind !== -1 && item.callbacks.splice(ind, 1);
        }
        else
            item.callbacks[reverse ? 'unshift' : 'push'](callback);
    };
}())
export function isUndefined(value){
    return typeof value === 'undefined';
}
export function openPopupCenter(url, title, w, h) {
    title = title || '';
    w = w || 900;
    h = h || 500;

    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}
export function getCurrScrollTop(){
    return (document.documentElement.scrollTop || document.body.scrollTop) + (document.querySelector('header')?.offsetHeight || 0);
}
export function limitsFormTypes(elem, opt, vm){
    if(typeof opt.highlighted === 'undefined') return;
    vm.$watch(() => opt.highlighted, bool => elem.dataset.checkmark = bool);
}
export function trimValue(value, useNormalTrim){
    if(typeof value !== 'string')
        return value;
    return useNormalTrim ? value.trim() : value.replace(/\s/g,'');
}
export function capitalizeString(str){
    return str.charAt(0).toUpperCase() + str.substr(1);
}
export function loadScript(src, success, error) {
    var script = document.createElement('script');
    var prior = document.getElementsByTagName('script')[0];
    script.async = 1;
    prior.parentNode.insertBefore(script, prior);

    script.onload = script.onreadystatechange = function(_, isAbort){
        if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
            script.onload = script.onreadystatechange = null;
            script = undefined;

            if (!isAbort) {
                if (success) success.call();
            }
        }
    };

    if(typeof error === 'function')
        script.onerror = error;

    script.src = src;

    return script;
}

function getPropIgnoreCase(object, caseSensitiveKey, returnKey){
	if(typeof returnKey !== 'boolean') returnKey = false;

	for(var key in object){
		if(key.toLowerCase() === (caseSensitiveKey + '').toLowerCase())
			return returnKey ? key : object[key];
	}
}

function inFS(){
	return Boolean(document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement);
}